export default function improvedTrim(str) {
  return str.split(' ').filter((el) => el !== '').join(' ');
}
